import React from 'react';
import PropTypes from 'prop-types';
import { StyledSaleLabel, StyledPlayerName } from './styled';

const NameCell = ({ cell }) => {
  const isListed = cell.row.original.forSale === 'For sale';
  const isLoanListed = cell.row.original.forLoan === 'For loan';
  const isAcademy = cell.row.original.academy?.status === 1;
  return (
    <>
      <StyledPlayerName>{cell.row.original.name}</StyledPlayerName>
      {isAcademy && <StyledSaleLabel isAcademy>Academy</StyledSaleLabel>}
      {isListed && <StyledSaleLabel>For sale</StyledSaleLabel>}
      {isLoanListed && <StyledSaleLabel $loan>For loan</StyledSaleLabel>}
    </>
  );
};
NameCell.propTypes = {
  cell: PropTypes.object.isRequired,
};
export default React.memo(NameCell);
